import { namespace } from 'vuex-class';
import { IDocumentViewState } from '@/document-view/store/document-view.types';

export const documentViewModuleName = 'documentView';
export const documentViewModulePath = documentViewModuleName;
export const DocumentView = namespace(documentViewModuleName);

export const getDefaultState: () => IDocumentViewState = () => ({
  loading: false,
  loaded: false,
  document: null,
  previewToken: {
    jwt: null,
    exp: null,
  },
  events: [],
  documentNotFound: false,
  revisionsLoading: false,
  updateFailed: false,
  notifications: [],
  dismissedEditPromptBar: false,

  loadedRecipientLinks: false,
  loadingRecipientLinks: false,
  recipientURLs: [],
  editorRecipientInput: [],
});

export enum EDocumentViewMutation {
  SetState = 'setState',
  SetDocument = 'setDocument',
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetPreviewToken = 'setPreviewToken',
  SetCancelScheduleModalVisibility = 'setCancelScheduleModalVisibility',
  SetTags = 'setTags',
  SetDocumentEvents = 'setDocumentEvents',
  SetDocumentNotFound = 'setDocumentNotFound',
  SetDocumentNotifications = 'setDocumentNotifications',
  SetDocumentRevisions = 'setDocumentRevisions',
  SetDocumentRevisionStatus = 'setDocumentRevisionStatus',
  SetRevisionsLoading = 'setRevisionsLoading',
  SetUpdateFailed = 'setUpdateFailed',
  SetPages = 'setPages',
  SetDismissedEditPromptBar = 'setDismissedEditPromptBar',

  SetLoadingRecipientLinks = 'setLoadingRecipientLinks',
  SetLoadedRecipientLinks = 'setLoadedReicpientLinks',
  SetRecipientURLs = 'setRecipientLinks',
  SetEditorRecipientInput = 'setEditorRecipientInput',
}

export enum EDocumentViewAction {
  ResetState = 'resetState',

  LoadDocument = 'loadDocument',
  LoadDocumentSuccess = 'loadDocumentSuccess',
  LoadDocumentFailed = 'loadDocumentFailed',

  LoadPageThumbnail = 'loadPageThumbnail',
  LoadPageThumbnailSuccess = 'loadPageThumbnailSuccess',

  LoadDocumentEvents = 'loadDocumentEvents',
  LoadDocumentEventsSuccess = 'loadDocumentEventsSuccess',

  UpdateDocument = 'updateDocument',
  UpdateDocumentFailed = 'updateDocumentFailed',
  SetDocument = 'setDocument',
  UpdatePageOrder = 'updatePageOrder',

  AddRecipient = 'addRecipient',
  LoadRecipients = 'loadRecipients',

  LoadEditorRecipientInput = 'loadEditorRecipientInput',
  LoadEditorRecipientInputSuccess = 'loadEditorRecipientInputSuccess',
  LoadEditorRecipientInputFailed = 'loadEditorRecipientInputFailed',

  GetPreviewToken = 'getPreviewToken',
  GetPreviewTokenSuccess = 'getPreviewTokenSuccess',
  GetPreviewTokenFailed = 'getPreviewTokenFailed',

  ToggleCancelScheduleModal = 'toggleCancelScheduleModal',

  CreateNewTag = 'createNewTag',
  AddTag = 'addTag',
  RemoveTag = 'removeTag',
  TagFailed = 'tagFailed',

  LoadDocumentNotifications = 'loadDocumentNotifications',
  LoadDocumentNotificationsSuccess = 'loadDocumentNotificationsSuccess',
  LoadDocumentNotificationsFailed = 'loadDocumentNotificationsFailed',

  AddDocumentNotification = 'addDocumentNotification',
  AddDocumentNotificationFailed = 'addDocumentNotificationFailed',

  DeleteDocumentNotification = 'deleteDocumentNotification',
  DeleteDocumentNotificationFailed = 'deleteDocumentNotificationFailed',

  ReplacePage = 'replacePage',
  UpdatePage = 'updatePage',
  AddPages = 'addPages',
  RemovePage = 'removePage',

  DisconnectResource = 'disconnectResource',
  DisconnectResourceFailed = 'disconnectResourceFailed',

  LoadDocumentRevisions = 'loadDocumentRevisions',
  LoadDocumentRevisionsSuccess = 'loadDocumentRevisionsSuccess',
  LoadDocumentRevisionsFailed = 'loadDocumentRevisionsFailed',

  SetDocumentRevisionStatus = 'setDocumentRevisionStatus',

  PublishDocument = 'publishDocument',
  PublishDocumentSuccess = 'publishDocumentSuccess',
  PublishDocumentFailed = 'publishDocumentFailed',

  DiscardChanges = 'discardChanges',
  DiscardChangesSuccess = 'discardChangesSuccess',
  DiscardChangesFailed = 'discardChangesFailed',

  EditorUpdateFailed = 'editorUpdateFailed',

  DismissEditPromptBar = 'dismissEditPromptBar',

  DocumentUpdated = 'documentUpdated',

  LoadRecipientURLs = 'loadRecipientURLs',
  LoadRecipientURLsSuccess = 'loadRecipientURLsSuccess',
  LoadRecipientURLsFailed = 'loadRecipientURLsFailed',
  StatusUpdated = 'StatusUpdated',
}
